import { useState } from "react";
import { agreementFieldNames } from "../../components/LoanApplication/agreements/utils";

const {
  CONSENT_DATA_VERIFICATION,
  CONSENT_DATA_VERIFICATION_LEPL,
  CONSENT_DATA_INCOME_REMITTANCE,
  CONSENT_DATA_FUTURE_OFFERS,
} = agreementFieldNames;

const initState = {
  [CONSENT_DATA_VERIFICATION]: false,
  [CONSENT_DATA_VERIFICATION_LEPL]: false,
  [CONSENT_DATA_INCOME_REMITTANCE]: false,
  [CONSENT_DATA_FUTURE_OFFERS]: false,
};

function useAgreementValues() {
  const [agreementValues, setAgreementValues] = useState(initState);
  return { agreementValues, setAgreementValues };
}

export default useAgreementValues;
